import { ChangePlanModal } from '@/components/Modals/ChangePlanModal';
import SimpleNotificationModal from '@/components/Modals/SimpleNotificationModal';
import { useAnalytics } from '@/services/analytics';
import { Billing } from '@/services/api';
import { useAuth } from '@/services/auth';
import { PaymentProvider } from '@/state/user-settings/types';
import { PlanGroup } from '@d-id/types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
    openPostCheckout: () => void;
}

export function ChangePlanModalWrapper({ openPostCheckout }: Props) {
    const { state } = useLocation();
    const [openMobileModal, setOpenMobileModal] = useState(false);
    const [isChangePlanOpen, setIsChangePlanOpen] = useState(false);
    const { newPriceId, newPlan, newInterval } = state || {};
    const mixpanel = useAnalytics();
    const { user } = useAuth();

    useEffect(() => {
        if (newPriceId) {
            if (user?.paymentProvider === PaymentProvider.AppStore) {
                mixpanel?.track('goto-mobile-manage-account', {
                    redirect: 'root',
                    cause: 'mobile user',
                });
                setOpenMobileModal(true);
            } else {
                setIsChangePlanOpen(true);
            }
        }
    }, [newPriceId, user?.paymentProvider]);

    if (!isChangePlanOpen) return null;
    return (
        <>
            <ChangePlanModal
                setIsOpen={setIsChangePlanOpen}
                newPlan={newPlan as PlanGroup}
                newInterval={newInterval as Billing}
                newPriceId={newPriceId as string}
                openPostCheckout={openPostCheckout}
            />
            <SimpleNotificationModal
                open={openMobileModal}
                onClose={() => {
                    setOpenMobileModal(false);
                }}
                content="Please use the mobile app to manage your plan."
                primaryActionContent="Got It"
                onPrimaryAction={() => {
                    setOpenMobileModal(false);
                }}
                buttonPlacement="center"
            />
        </>
    );
}
